import type { RootStateType } from '@/features/store';

/**
 * Получить состояние слайса избранных
 */
const favoritesSelector = (state: RootStateType) => state.favorites;

export default favoritesSelector;
